import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmBtnComponent } from './sm-btn.component';



@NgModule({
  declarations: [
    SmBtnComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[SmBtnComponent]
})
export class SmBtnModule { }
